var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "bg-white py-8 border-b-2 border-gray-300" }, [
      _c(
        "div",
        {
          staticClass: "w-full md:w-10/12 mx-auto flex flex-wrap px-4 md:px-0"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex w-full md:w-2/3 lg:w-1/2 flex-col justify-center items-start"
            },
            [
              _c("h2", { staticClass: "font-bold text-2xl" }, [
                _vm._v("Hi, " + _vm._s(_vm.$store.state.loggedInUser.name))
              ]),
              _c("div", { staticClass: "flex items-center mt-5" }, [
                _c("h3", { staticClass: "text-xl text-gray-600 mr-5" }, [
                  _vm._v("Current Plan:")
                ]),
                _c(
                  "div",
                  {
                    staticClass: "text-center px-6 py-1 rounded-full font-bold",
                    class: {
                      "bg-yellow-400 text-yellow-800":
                        _vm.$store.state.loggedInUser.plan == "Free",
                      "bg-blue-400 text-blue-800":
                        _vm.$store.state.loggedInUser.plan == "Pro",
                      "bg-purple-300 text-purple-800":
                        _vm.$store.state.loggedInUser.plan == "Enterprise"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$store.state.loggedInUser.plan))]
                )
              ]),
              _vm._m(0),
              _vm._m(1)
            ]
          ),
          _c("div", {
            staticClass:
              "flex w-full md:w-1/3 lg:w-1/2 flex-col py-4 justify-center items-end"
          })
        ]
      ),
      _vm.showUpgradePlanModal
        ? _c(
            "div",
            {
              staticClass:
                "fixed flex justify-center items-center px-5 sm:px-10 md:px-20 lg:px-40 py-5 sm:py-20 lg:py-32 inset-0"
            },
            [
              _c("div", {
                staticClass: "fixed inset-0 bg-black-background-faint",
                on: {
                  click: function($event) {
                    _vm.showUpgradePlanModal = false
                  }
                }
              }),
              _c(
                "div",
                {
                  staticClass:
                    "rounded bg-white w-full h-full z-50 overflow-y-scroll"
                },
                [
                  _c(
                    "header",
                    {
                      staticClass:
                        "bg-gray-100 border-b-2 border-gray-300 p-6 flex justify-between items-center"
                    },
                    [
                      _c("h2", { staticClass: "font-bold text-2xl" }, [
                        _vm._v("Change Plan")
                      ]),
                      _c(
                        "button",
                        {
                          staticClass:
                            "bg-white hover:bg-gray-100 text-gray-800 p-1 border border-gray-400 rounded hover:shadow",
                          on: { click: _vm.closeModal }
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "fill-current h-8",
                              attrs: { viewBox: "0 0 24 24" }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  !_vm.hasError
                    ? _c("div", { staticClass: "p-6" }, [
                        _c("div", { staticClass: "flex" }, [
                          _c(
                            "h3",
                            { staticClass: "text-xl text-gray-600 mr-5" },
                            [_vm._v("Current Plan:")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-center px-6 py-1 rounded-full font-bold",
                              class: {
                                "bg-yellow-400 text-yellow-800":
                                  _vm.$store.state.loggedInUser.plan == "Free",
                                "bg-blue-400 text-blue-800":
                                  _vm.$store.state.loggedInUser.plan == "Pro",
                                "bg-purple-300 text-purple-800":
                                  _vm.$store.state.loggedInUser.plan ==
                                  "Enterprise"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$store.state.loggedInUser.plan))]
                          )
                        ]),
                        _c("div", { staticClass: "flex flex-col pt-6" }, [
                          _c(
                            "div",
                            { staticClass: "flex flex-wrap -mx-2 -mb-4" },
                            [
                              _vm.$store.state.loggedInUser.plan != "Free"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "w-full md:w-1/2 px-2 mb-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-col p-6 border-2 border-gray-200 rounded hover:bg-gray-200",
                                          class: {
                                            "bg-gray-200 border-yellow-200 shadow-lg":
                                              _vm.selectedUpgradePlan == "Free"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.selectedUpgradePlan = "Free"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center px-6 py-1 mx-auto rounded-full bg-yellow-300 font-bold text-yellow-800"
                                            },
                                            [_vm._v("Free")]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass: "mt-2 text-gray-700"
                                            },
                                            [
                                              _vm._v(
                                                "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Exercitationem a, quibusdam provident cum sequi, nemo doloremque placeat nobis, quod voluptas illo recusandae. Exercitationem sint sed amet non voluptatem cumque aliquam."
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.$store.state.loggedInUser.plan != "Pro"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "w-full md:w-1/2 px-2 mb-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-col p-6 border-2 border-gray-200 rounded hover:bg-gray-200",
                                          class: {
                                            "bg-gray-200 border-blue-200 shadow-lg":
                                              _vm.selectedUpgradePlan == "Pro"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.selectedUpgradePlan = "Pro"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center px-6 py-1 mx-auto rounded-full bg-blue-300 font-bold text-blue-800"
                                            },
                                            [_vm._v("Pro")]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass: "mt-2 text-gray-700"
                                            },
                                            [
                                              _vm._v(
                                                "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Exercitationem a, quibusdam provident cum sequi, nemo doloremque placeat nobis, quod voluptas illo recusandae. Exercitationem sint sed amet non voluptatem cumque aliquam."
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.$store.state.loggedInUser.plan != "Enterprise"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "w-full md:w-1/2 px-2 mb-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-col p-6 border-2 border-gray-200 rounded hover:bg-gray-200",
                                          class: {
                                            "bg-gray-200 border-purple-200 shadow-lg":
                                              _vm.selectedUpgradePlan ==
                                              "Enterprise"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.selectedUpgradePlan =
                                                "Enterprise"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center px-6 py-1 mx-auto rounded-full bg-purple-300 font-bold text-purple-800"
                                            },
                                            [_vm._v("Enterprise")]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass: "mt-2 text-gray-700"
                                            },
                                            [
                                              _vm._v(
                                                "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Exercitationem a, quibusdam provident cum sequi, nemo doloremque placeat nobis, quod voluptas illo recusandae. Exercitationem sint sed amet non voluptatem cumque aliquam."
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm.selectedUpgradePlan != ""
                            ? _c("div", [
                                _c("div", { staticClass: "my-4" }, [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "fill-current h-10 mx-auto",
                                      attrs: { viewBox: "0 0 24 24" }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _vm.$store.state.loggedInUser.stripe_id != null
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "border-l-4 border-green-400 bg-green-200 text-green-800 py-5 rounded pl-4"
                                      },
                                      [
                                        _vm._v(
                                          "You have payment details attached to your account."
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.$store.state.loggedInUser.stripe_id == null
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "border-l-4 border-red-400 bg-red-200 text-reg-800 py-5 rounded pl-4"
                                      },
                                      [
                                        _c("p", { staticClass: "mb-2" }, [
                                          _vm._v(
                                            "You have no payment details attached to your account."
                                          )
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            "In order to add payment details please continue to Stripe."
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _c("div", { staticClass: "my-4" }, [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "fill-current h-10 mx-auto",
                                      attrs: { viewBox: "0 0 24 24" }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _vm.$store.state.loggedInUser.stripe_id != null
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "w-full bg-blue-200 hover:bg-blue-300 text-blue-900 font-semibold py-4 px-4 border border-blue-400 rounded hover:shadow flex items-center justify-center",
                                        on: { click: _vm.completeUpgrade }
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "fill-current h-8 w-8 mr-5",
                                            attrs: { viewBox: "0 0 24 24" }
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d:
                                                  "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
                                              }
                                            })
                                          ]
                                        ),
                                        _c("span", [
                                          _vm._v("Complete Plan Change")
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.$store.state.loggedInUser.stripe_id == null
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "w-full bg-blue-200 hover:bg-blue-300 text-blue-900 font-semibold py-4 px-4 border border-blue-400 rounded hover:shadow",
                                        on: { click: _vm.continueToStripe }
                                      },
                                      [_vm._v("Continue to Payment Portal")]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm.hasError
                    ? _c("div", { staticClass: "p-40" }, [_vm._m(2)])
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e()
    ]),
    _c("section", { staticClass: "py-8" }, [
      _c(
        "div",
        { staticClass: "w-full md:w-10/12 mx-auto flex flex-col px-4 md:px-0" },
        [
          _c("h2", { staticClass: "text-2xl font-semibold" }, [
            _vm._v("Downloads")
          ]),
          _c(
            "div",
            {
              staticClass: "rounded shadow bg-white mt-5 flex flex-col sm:p-8"
            },
            [
              _c("div", {
                staticClass:
                  "hidden sm:flex sm:border-b-2 border-gray-200 sm:-mx-8 px-8"
              }),
              _vm._l(_vm.downloads, function(download, d) {
                return _c(
                  "div",
                  {
                    key: d,
                    staticClass:
                      "sm:hover:bg-gray-100 border-b-2 border-gray-200 sm:-mx-8 sm:px-8 sm:py-4"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-col flex-wrap sm:hidden p-10" },
                      [
                        _c("div", { staticClass: "flex" }, [
                          _c(
                            "span",
                            { staticClass: "text-xl font-semibold mr-2" },
                            [_vm._v(_vm._s(download.title))]
                          ),
                          _c("span", { staticClass: "text-gray-700" }, [
                            _vm._v("(" + _vm._s(download.version) + ")")
                          ])
                        ]),
                        _c("span", { staticClass: "mt-2 mb-4 text-gray-600" }, [
                          _vm._v(_vm._s(download.description))
                        ]),
                        _c(
                          "div",
                          { staticClass: "flex justify-center w-full mt-2" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "bg-white hover:bg-gray-200 text-gray-800 text-sm py-4 px-8 border border-gray-400 rounded hover:shadow mr-2 text-center",
                                attrs: {
                                  href:
                                    _vm.publicPath +
                                    "downloads/" +
                                    download.file_name,
                                  target: "_blank"
                                }
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass:
                                      "fill-current h-8 mb-2 mx-auto",
                                    attrs: { viewBox: "0 0 24 24" }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"
                                      }
                                    }),
                                    _vm._v("/> ")
                                  ]
                                ),
                                _c("span", [_vm._v("Download Bundle")])
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _c("div", { staticClass: "hidden sm:flex" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-full flex items-center justify-between"
                        },
                        [
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "flex items-center" }, [
                              _c(
                                "span",
                                { staticClass: "text-xl font-semibold mr-2" },
                                [_vm._v(_vm._s(download.title))]
                              ),
                              _c("span", { staticClass: "text-gray-700" }, [
                                _vm._v("(" + _vm._s(download.version) + ")")
                              ])
                            ]),
                            _c("span", { staticClass: "text-gray-600" }, [
                              _vm._v(_vm._s(download.description))
                            ])
                          ]),
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "bg-white hover:bg-gray-200 text-gray-800 text-sm py-2 pl-3 pr-4 border border-gray-400 rounded hover:shadow inline-flex items-center my-1",
                                attrs: {
                                  href:
                                    _vm.publicPath +
                                    "downloads/" +
                                    download.file_name,
                                  target: "_blank"
                                }
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "fill-current h-5 w-5 mr-2",
                                    attrs: { viewBox: "0 0 24 24" }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"
                                      }
                                    })
                                  ]
                                ),
                                _c("span", [_vm._v("Download Bundle")])
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ]
                )
              })
            ],
            2
          )
        ]
      )
    ]),
    _c("section", { staticClass: "py-8" }, [
      _c(
        "div",
        { staticClass: "w-full md:w-10/12 mx-auto flex flex-col px-4 md:px-0" },
        [
          _c("h2", { staticClass: "text-2xl font-semibold" }, [
            _vm._v("Payments")
          ]),
          _c(
            "div",
            {
              staticClass: "rounded shadow bg-white mt-5 flex flex-col sm:p-8"
            },
            [
              !_vm.invoicesLoading
                ? _c(
                    "div",
                    [
                      _vm.$store.state.loggedInUser.stripe_invoices != null
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "hidden sm:flex sm:border-b-2 border-gray-200 sm:-mx-8 px-8"
                            },
                            [
                              _c("div", { staticClass: "w-3/12 font-bold" }, [
                                _vm._v("Invoice No")
                              ]),
                              _c("div", { staticClass: "w-3/12 font-bold" }, [
                                _vm._v("Invoice Date")
                              ]),
                              _c("div", { staticClass: "w-1/12 font-bold" }, [
                                _vm._v("Total")
                              ]),
                              _c("div", { staticClass: "w-2/12 font-bold" }, [
                                _vm._v("Paid")
                              ]),
                              _c("div", { staticClass: "w-3/12 font-bold" }, [
                                _vm._v("Invoice")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._l(
                        _vm.$store.state.loggedInUser.stripe_invoices,
                        function(invoice, i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              staticClass:
                                "sm:hover:bg-gray-100 border-b-2 border-gray-200 sm:-mx-8 sm:px-8 sm:py-4"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "flex flex-wrap sm:hidden p-10"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex flex-1 flex-col" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-lg text-gray-700"
                                        },
                                        [_vm._v(_vm._s(invoice.number))]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-lg text-gray-700"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              new Date(
                                                invoice.created * 1000
                                              ).toDateString()
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-0 flex-col items-end"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-lg text-gray-700"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              invoice.currency == "gbp"
                                                ? "£"
                                                : invoice.currency + " "
                                            ) + _vm._s(invoice.total / 100)
                                          )
                                        ]
                                      ),
                                      invoice.paid == true
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "bg-green-300 text-green-900 font-bold py-1 px-5 text-center rounded-full"
                                            },
                                            [_vm._v("Paid")]
                                          )
                                        : _vm._e(),
                                      invoice.paid == false
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "bg-red-300 text-red-900 font-bold py-1 px-5 text-center rounded-full"
                                            },
                                            [_vm._v("Not Paid")]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex w-full mt-2" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "bg-white w-full hover:bg-gray-200 text-gray-800 text-sm py-4 border border-gray-400 rounded hover:shadow mr-2 text-center",
                                          attrs: {
                                            href: invoice.invoice_pdf,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "fill-current h-8 mb-2 mx-auto",
                                              attrs: { viewBox: "0 0 24 24" }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M10.59,10.08C10.57,10.13 10.3,11.84 8.5,14.77C8.5,14.77 5,16.58 5.83,17.94C6.5,19 8.15,17.9 9.56,15.27C9.56,15.27 11.38,14.63 13.79,14.45C13.79,14.45 17.65,16.19 18.17,14.34C18.69,12.5 15.12,12.9 14.5,13.09C14.5,13.09 12.46,11.75 12,9.89C12,9.89 13.13,5.95 11.38,6C9.63,6.05 10.29,9.12 10.59,10.08M11.4,11.13C11.43,11.13 11.87,12.33 13.29,13.58C13.29,13.58 10.96,14.04 9.9,14.5C9.9,14.5 10.9,12.75 11.4,11.13M15.32,13.84C15.9,13.69 17.64,14 17.58,14.32C17.5,14.65 15.32,13.84 15.32,13.84M8.26,15.7C7.73,16.91 6.83,17.68 6.6,17.67C6.37,17.66 7.3,16.07 8.26,15.7M11.4,8.76C11.39,8.71 11.03,6.57 11.4,6.61C11.94,6.67 11.4,8.71 11.4,8.76Z"
                                                }
                                              })
                                            ]
                                          ),
                                          _c("span", [_vm._v("Download PDF")])
                                        ]
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "bg-white w-full hover:bg-gray-200 text-gray-800 text-sm py-4 border border-gray-400 rounded hover:shadow ml-2 text-center",
                                          attrs: {
                                            href: invoice.hosted_invoice_url,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "fill-current h-8 mb-2 mx-auto",
                                              attrs: { viewBox: "0 0 24 24" }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                                                }
                                              })
                                            ]
                                          ),
                                          _c("span", [_vm._v("Online Invoice")])
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c("div", { staticClass: "hidden sm:flex" }, [
                                _c(
                                  "div",
                                  { staticClass: "w-3/12 flex items-center" },
                                  [_c("span", [_vm._v(_vm._s(invoice.number))])]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "w-3/12 flex items-center" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        new Date(
                                          invoice.created * 1000
                                        ).toDateString()
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "w-1/12 flex items-center" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        invoice.currency == "gbp"
                                          ? "£"
                                          : invoice.currency + " "
                                      ) + _vm._s(invoice.total / 100)
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "w-2/12 flex items-center" },
                                  [
                                    invoice.paid == true
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "bg-green-300 text-green-900 font-bold py-1 px-5 text-center rounded-full"
                                          },
                                          [_vm._v("Paid")]
                                        )
                                      : _vm._e(),
                                    invoice.paid == false
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "bg-red-300 text-red-900 font-bold py-1 px-5 text-center rounded-full"
                                          },
                                          [_vm._v("Not Paid")]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "w-3/12 flex flex-wrap justify-between"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "bg-white hover:bg-gray-200 text-gray-800 text-sm py-2 pl-3 pr-4 border border-gray-400 rounded hover:shadow inline-flex items-center my-1",
                                        attrs: {
                                          href: invoice.invoice_pdf,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "fill-current h-5 w-5 mr-2",
                                            attrs: { viewBox: "0 0 24 24" }
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d:
                                                  "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M10.59,10.08C10.57,10.13 10.3,11.84 8.5,14.77C8.5,14.77 5,16.58 5.83,17.94C6.5,19 8.15,17.9 9.56,15.27C9.56,15.27 11.38,14.63 13.79,14.45C13.79,14.45 17.65,16.19 18.17,14.34C18.69,12.5 15.12,12.9 14.5,13.09C14.5,13.09 12.46,11.75 12,9.89C12,9.89 13.13,5.95 11.38,6C9.63,6.05 10.29,9.12 10.59,10.08M11.4,11.13C11.43,11.13 11.87,12.33 13.29,13.58C13.29,13.58 10.96,14.04 9.9,14.5C9.9,14.5 10.9,12.75 11.4,11.13M15.32,13.84C15.9,13.69 17.64,14 17.58,14.32C17.5,14.65 15.32,13.84 15.32,13.84M8.26,15.7C7.73,16.91 6.83,17.68 6.6,17.67C6.37,17.66 7.3,16.07 8.26,15.7M11.4,8.76C11.39,8.71 11.03,6.57 11.4,6.61C11.94,6.67 11.4,8.71 11.4,8.76Z"
                                              }
                                            })
                                          ]
                                        ),
                                        _c("span", [_vm._v("Download PDF")])
                                      ]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "bg-white hover:bg-gray-200 text-gray-800 text-sm py-2 pl-3 pr-4 border border-gray-400 rounded hover:shadow inline-flex items-center my-1",
                                        attrs: {
                                          href: invoice.hosted_invoice_url,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "fill-current h-5 w-5 mr-2",
                                            attrs: { viewBox: "0 0 24 24" }
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d:
                                                  "M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                                              }
                                            })
                                          ]
                                        ),
                                        _c("span", [_vm._v("Online Invoice")])
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        }
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm.invoicesLoading
                ? _c(
                    "div",
                    { staticClass: "flex items-center justify-center" },
                    [
                      _c("span", {
                        staticClass:
                          "mdi mdi-loading mdi-spin text-5xl text-gray-500"
                      })
                    ]
                  )
                : _vm._e(),
              _vm.$store.state.loggedInUser.stripe_invoices == null ||
              _vm.isLoading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "bg-blue-200 border-l-4 border-blue-600 rounded pl-4 py-6 text-blue-900 flex items-center"
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "fill-current h-12 w-12 mr-4",
                          attrs: { viewBox: "0 0 24 24" }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"
                            }
                          })
                        ]
                      ),
                      _c("h3", { staticClass: "text-lg" }, [
                        _vm._v("You have no invoices to show.")
                      ])
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mt-5 text-gray-600" }, [
      _vm._v(" Welcome to your Webpart Store account portal. "),
      _c("br"),
      _vm._v("Please find your available downloads below. ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mt-5 text-gray-600" }, [
      _vm._v(" For more information on installing the webpart see "),
      _c(
        "a",
        {
          attrs: {
            href: "https://docs.microsoft.com/en-us/sharepoint/use-app-catalog",
            target: "_blank"
          }
        },
        [_vm._v("here")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "w-full h-full bg-red-200 p-16 border-l-4 border-red-600 rounded text-red-800"
      },
      [
        _c("h2", { staticClass: "text-2xl font-bold" }, [_vm._v("Error")]),
        _c("p", { staticClass: "mt-2 text-lg" }, [
          _vm._v(
            "There has been an error upgrading your plan. Please try again later"
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }